import { Injectable } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';

@Injectable({
  providedIn: 'root'
})
export class CustomValidatorsService {

  /** Validate required fields have at lease one character that is not whitespace */
  validateRequiredField(c: UntypedFormControl) {
    const regex = /[a-zA-Z0-9]/;

    if (!c.value) {
      return null;
    }

    return regex.test(c.value) ? null : {
      validateField: {
        valid: false
      }
    };
  }

  vendorSerachPageDateValidator(g: UntypedFormGroup) {
    if (g.controls.caseOrderEndDate.value < g.controls.caseOrderStartDate.value) {
      g.controls.caseOrderEndDate.setErrors({ 'incorrect': true });
      return { notValid: true };
    }
    return true;
  }

  validatePhoneNumber(c: UntypedFormControl) {
    const regex = /^\s*(?:\+?(\d{1,3}))?[-. (]*(\d{3})[-. )]*(\d{3})[-. ]*(\d{4})(?: *x(\d+))?\s*$/;

    if (!c.value) {
      return null;
    }

    return regex.test(c.value) ? null : {
      validateField: {
        valid: false
      }
    }
  }

  validateEndSpace(c: UntypedFormControl) {
    const regex = /\s$/;

    if (!c.value) {
      return null;
    }

    return !regex.test(c.value) ? null : {
      validateField: {
        valid: false
      }
    }
  }

  validateDigits(c: UntypedFormControl) {
    const regex = /^\d+$/;

    if (!c.value) {
      return null;
    }

    return regex.test(c.value) ? null : {
      validateField: {
        valid: false
      }
    }
  }

  validComapyCode(c: UntypedFormControl) {
    const regex = /^\d{5}-\d{7}$/;

    if (!c.value) {
      return null;
    }

    return regex.test(c.value) ? null : {
      validateField: {
        valid: false
      }
    }
  }

  globalValidation(c: UntypedFormControl) {
    const regex = /^[a-zA-Z0-9\$@\',\-_\.;:\\ ]+$/;

    return regex.test(c.value) ? null : {
      validateField: {
        valid: false
      }
    }

  }

}
